import React, {Fragment,useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Typeahead } from 'react-bootstrap-typeahead';
import XLSX from 'xlsx';
import gql from 'graphql-tag';
import moment from 'moment';
import PageTitle from '../../Layout/AppMain/PageTitle';
import * as FileSaver from 'file-saver';

import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import {
    Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter,Progress,FormFeedback,
    InputGroup, FormGroup, Label, Input, ButtonToggle, Spinner, UncontrolledTooltip, TabContent, TabPane,
    CardFooter,
    CardHeader
  } from 'reactstrap';

import {
    Col,CardTitle,
    Card,Form, FormText ,
    CardBody, Button, InputGroupAddon
  } from 'reactstrap';


  const GenerateToken = ({ history }) => {
    const [accessToken, setAccessToken] = useState(null);
    const [refreshToken, setRefreshToken] = useState(null);
    const [foundToken, setFoundToken] = useState(false);
    const [checkToken, setCheckToken] = useState(false);
    const [tokenExists, setTokenExists] = useState(false);
    const [tokenExpiresAt, setTokenExpiresAt] = useState(null);
    const [tokenGeneratedAt, setTokenGeneratedAt] = useState(null);
    const [refreshTokenExpiresAt, setRefreshTokenExpiresAt] = useState(null);

    useEffect(() => {
        if (!checkToken) {
            setCheckToken(true);
            getSupplierTokens();  
        }
    }, []);

    //function to generate token from the server

    const getSupplierTokens = async () => {
        const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;

        let url = window.location.origin + '/get_supplier_token';
  
        if (window.location.hostname === 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/get_supplier_token';
        }
        const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token || null,
            "authVendorID": localStorage.getItem('loggedInVendor'),
            "loggedInUser": JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name,
            "loggedInEmail": JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.email
        }
        });

        try {
            const responseData = await response.json();
            if (responseData && responseData.token)   {
                setFoundToken(true);
            } else if (responseData.error) {
                setTokenExists(false);
            }

          } catch(error) {
            console.log(error); 
          } finally {
           
          }
      
    }

    const generateToken = async () => {
        const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;

        let url = window.location.origin + '/generate_supplier_token';
  
        if (window.location.hostname === 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/generate_supplier_token';
        }
        const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token || null,
            "authVendorID": localStorage.getItem('loggedInVendor'),
            "loggedInUser": JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name,
            "loggedInEmail": JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.email
        }
        });

        try {
            const responseData = await response.json();
           
            if (responseData && responseData.token)   {
                setAccessToken(responseData.token.token   )
                setRefreshToken(responseData.token.refresh_token)
                setTokenGeneratedAt(responseData.token.token_generatedAt)
                setTokenExpiresAt(responseData.token.token_expiresAt)
                setRefreshTokenExpiresAt(responseData.token.refresh_token_expiresAt)
                console.log(responseData.token.token , responseData.token.refresh_token)

            }
          } catch(error) {
            console.log(error); 
          } finally {
           
          }
      
    }

    return (

        <div className="animated fadeIn">
            <PageTitle title="Generate Token" />
            <div className="row">
                <div className="col-md-12">
                    {(foundToken)?
                    <Card>
                        <CardHeader>
                            Token Details
                        </CardHeader>
                        <CardBody>
                            {(accessToken && refreshToken)?
                                <FormGroup>
                                    <b>Token created successfully!</b>
                                    <p>
                                        Please make a note of this token as it will be the only time that you will be able to view it. After this, it will be stored as a hash for your protection.
                                    </p>
                                    <Label for="accessToken">Access Token</Label>
                                    <Input type="text" value={accessToken} readOnly />

                                    <Label for="refreshToken">Refresh Token</Label>
                                    <Input type="text" value={refreshToken} readOnly />

                                    <Label for="refreshToken">Token Generated At</Label>
                                    <Input type="text" value={tokenGeneratedAt} readOnly />

                                    <Label for="refreshToken">Token Expires At</Label>
                                    <Input type="text" value={tokenExpiresAt} readOnly />

                                    <Label for="refreshToken">Refresh Token Expires At</Label>
                                    <Input type="text" value={refreshTokenExpiresAt} readOnly />

                                  

                                </FormGroup>:
                                <div style={{ textAlign: 'center', color: 'green', fontWeight: 'bold' }}>Please click on Generate Token to generate a new Token.</div>}
                        </CardBody>
                        <CardFooter style={{textAlign:'center'}}>
                        
                                <Button style={{marginLeft:'auto'}} color="primary" onClick={() => generateToken() }>Generate Token</Button>
                          
                        </CardFooter>
                    </Card>: 

                                <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}> Not Authorized</div>
                            }

                 
                </div>
            </div>
        </div>
    )

  }

  export default GenerateToken;
